import { render, staticRenderFns } from "./cv-villas.vue?vue&type=template&id=adee4baa"
import script from "./cv-villas.vue?vue&type=script&lang=js"
export * from "./cv-villas.vue?vue&type=script&lang=js"
import style0 from "./cv-villas.vue?vue&type=style&index=0&id=adee4baa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports